import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-divider',
  standalone: true,
  template: '',
  styles: [
    `
      .app-divider {
        display: block;
        margin: 0;
      }
      .app-divider--horizontal {
        border-top-width: 1px;
        border-top-style: solid;
        border-top-color: #eee;
        margin: 0.5rem 0;
      }
      .app-divider--vertical {
        height: 100%;
        border-left-width: 1px;
        border-left-style: solid;
        border-left-color: #eee;
      }
    `
  ],
  encapsulation: ViewEncapsulation.None
})
export class DividerComponent {
  @Input()
  get vertical(): boolean {
    return this.isVertical;
  }
  set vertical(value: boolean) {
    this.isVertical = coerceBooleanProperty(value);
  }
  private isVertical = false;

  @HostBinding('class')
  get hostClasses(): Record<string, boolean> {
    const hostClasses: { [key: string]: boolean } = {
      'app-divider': true,
    };

    const orientation = this.vertical ? 'vertical' : 'horizontal';
    hostClasses[`app-divider--${orientation}`] = true;

    return hostClasses;
  }

  // The following were taken as an example from the Material mat-divider component
  // Reference: https://github.com/angular/components/blob/master/src/material/divider/divider.ts
  @HostBinding('attr.role') role = 'separator';
  @HostBinding('attr.aria-orientation') orientation = this.vertical ? 'vertical' : 'horizontal';
}
